module.exports = __webpack_public_path__ + "img/thumbUp1_ws.e66d82b8.png";